/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ScholarshiptypeIdPercentage200,
  GetApiV1ScholarshiptypeIdPercentage401,
  GetApiV1ScholarshiptypeIdPercentage500,
  GetApiV1ScholarshiptypeIdPercentagePathParams,
  GetApiV1ScholarshiptypeIdPercentageQueryResponse,
} from "../../types/scholarshipTypeRegistroController/GetApiV1ScholarshiptypeIdPercentage.ts";

export const getApiV1ScholarshiptypeIdPercentagePathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ScholarshiptypeIdPercentagePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ScholarshiptypeIdPercentage200Schema =
  z.number() as unknown as ToZod<GetApiV1ScholarshiptypeIdPercentage200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ScholarshiptypeIdPercentage401Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeIdPercentage401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ScholarshiptypeIdPercentage500Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeIdPercentage500>;

export const getApiV1ScholarshiptypeIdPercentageQueryResponseSchema = z.lazy(
  () => getApiV1ScholarshiptypeIdPercentage200Schema,
) as unknown as ToZod<GetApiV1ScholarshiptypeIdPercentageQueryResponse>;
